<template>
  <div>
    <a-modal v-model="docModal" title="文档预览" :footer="null" width="1000">
      <a-spin :spinning="spinning">
        <div style="height:700px;overflow: hidden">
          <iframe :src="docSrc" id="iframeF" frameborder="0" style="width:100%;height:100%;"></iframe>
        </div>
      </a-spin>
    </a-modal>

    <a-modal :visible="imgModal" :footer="null" @cancel="imgModal = false">
      <img style="width: 100%" :src="imgSrc" />
    </a-modal>

    <a-modal :visible="videoModal" :footer="null" @cancel="videoModal = false">
      <video-player
        class="vjs-custom-skin"
        ref="videoPlayer"
        :options="playerOptions"
        :playsinline="true"
      >
      </video-player>
    </a-modal>
  </div>
</template>

<script>
import { axios } from '@/utils/request'

export default {
  name: 'PreView',
  props: {
    preViewImgUrl: String,
    preViewFileUrl: String
  },
  computed: {
    player () {
      return this.$refs.videoPlayer.player
    }
  },
  watch: {
    videoModal (flag) {
      if (!flag) {
        this.$refs.videoPlayer.player.pause()
      }
    }
  },
  data () {
    return {
      // 图片
      imgSrc: '',
      imgModal: false,
      imgTypeList: ['bmp', 'jpg', 'jpeg', 'png'],
      // 文件
      docSrc: '',
      docModal: false,
      docTypeList: ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'txt'],
      spinning: false,
      // 视频
      filePath: '',
      playsinline: true,
      videoModal: false,
      playerOptions: { playbackRates: [0.25, 0.75, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          // type: 'video/ogg',
          // type: 'video/webm',
          type: 'video/mp4',
          src: '' // 视频url地址
        }],
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: true,
          fullscreenToggle: true // 全屏按钮
        }
      },
      // 无法预览文件类型
      noReviewList: ['csv', 'wps', 'avi', 'rmvb', 'rm', 'flv', 'wmv', 'asf']
    }
  },
  methods: {
    // 预览
    handleView (model) {
      // console.log('this.$store.state.user.token', this.$store.state.user.token)
      // console.log('model', model)
      const filePath = model.filePath
      this.filePath = filePath
      this.spinning = true

      if (this.imgTypeList.indexOf(filePath.split('.')[1].toLowerCase()) !== -1) {
        axios({
          url: this.preViewImgUrl + `${filePath}`,
          responseType: 'blob',
          timeout: 5 * 60 * 1000,
          method: 'GET'
        }).then(res => {
          if (!res) {
            return
          }
          // var filename = model.fileName
          const url = window.URL.createObjectURL(res)
          this.imgSrc = url
          this.imgModal = true
        })
      } else if (this.docTypeList.indexOf(filePath.split('.')[1].toLowerCase()) !== -1) {
        // 预览的文件路径
        this.docSrc = this.preViewFileUrl + filePath.split('.')[0] + '.html'
        this.docModal = true
      } else if (this.noReviewList.indexOf(filePath.split('.')[1].toLowerCase()) !== -1) {
        this.$message.error('该类型文件暂不支持预览')
      } else {
        // this.playerOptions.sources[0].src = this.preViewFileUrl + filePath

        this.videoModal = true
        this.playerOptions.sources[0].src = this.preViewFileUrl + filePath + '?token=' + this.$store.state.user.token

        //   var vm = this
        //   const xhr = new XMLHttpRequest()
        //   xhr.open('get', this.preViewFileUrl + filePath, true)
        //   //设置请求头
        //   xhr.setRequestHeader('Authorization', this.$store.state.user.token)
        //   xhr.send()
        //   xhr.onreadystatechange = function() {
        //     if (this.readyState === 4) {
        //       if (this.status === 200) {
        //         const res = this.response || this.responseText
        //         const blob = new Blob([res], { type: 'video/mp4' })
        //         const blobUrl = URL.createObjectURL(blob)
        //         console.log("准备就绪",blobUrl)
        //         document.querySelector('.videoPlay').src = blobUrl
        //         vm.playerOptions.sources[0].src = blobUrl
        //       }
        //     }
        //   }
      }
      this.spinning = false
      // setTimeout(() => {
      //   this.spinning = false
      // }, 1000)
    },
    getData () {
      setTimeout(() => {
        // var score = document.getElementById('iframeF').contentWindow.document.body.scrollTop
        console.log("document.getElementById('iframeF')", document.getElementById('iframeF'))
        console.log("document.getElementById('iframeF')", document.getElementById('iframeF').contentWindow)
        console.log("document.getElementById('iframeF')", document.getElementById('iframeF').contentWindow.document)
      // console.log("score",score)
      }, 2000)
    }
  }
}
</script>
